import React from 'react';
import { Avatar, formatRevenue } from './Shared/AnalyticsComponents';

const PerformersTable = ({ team, loading }) => {
    return (
        <div className="performers-table-card">
            <div className="table-header-box">
                <h2>Top Performers</h2>
                <span>Ranked by win rate</span>
            </div>
            <div className="table-wrapper" style={{ overflowX: 'auto' }}>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Team Member</th>
                            <th>Proposals</th>
                            <th>Win Rate</th>
                            <th>Avg Response</th>
                            <th>Revenue Won</th>
                        </tr>
                    </thead>
                    <tbody>
                        {team.map((p, i) => {
                            const winRateVal = p.win_rate ?? 0;
                            const winRateColor = winRateVal >= 70 ? "#10B981" : winRateVal > 0 ? "#FF5526" : "#94A3B8";

                            return (
                                <tr key={p.user_id || p._id || p.name}>
                                    <td>
                                        <div className={`rank-badge-container ${i === 0 ? "rank-1" : i === 1 ? "rank-2" : i === 2 ? "rank-3" : "rank-default"}`}>
                                            {i + 1}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="member-cell">
                                            <Avatar name={p.name} size={32} />
                                            <span className="member-name-text">{p.name}</span>
                                        </div>
                                    </td>
                                    <td className="data-cell-numeric">{p.total_rfps || 0}</td>
                                    <td>
                                        <span className="status-highlight" style={{ color: winRateColor }}>
                                            {winRateVal.toFixed(1)}%
                                        </span>
                                    </td>
                                    <td className="data-cell-secondary">{p.avg_response_time || 'N/A'}</td>
                                    <td>
                                        <span className="revenue-highlight">{formatRevenue(p.revenue || 0)}</span>
                                    </td>
                                </tr>
                            );
                        })}
                        {team.length === 0 && !loading && (
                            <tr>
                                <td colSpan="6" className="text-center py-10 text-slate-400">No performance data found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PerformersTable;
